export const DENIED_STORE_STATUSES = [0, 2, 3]

export const IS_APP_VISIBLE_STORAGE_KEY = 'IS_APP_VISIBLE'

export const SCROLL_ORDER_QUERY_ID = 'id'

export const NOTIFICATION_PENDING_ORDER_ID = 'NOTIFICATION_PENDING_ORDER_ID'

export const NOTIFICATION_APP_ID = 'NOTIFICATION_APP_ID'

// Store availability status 
export const STORE_AVAILABILITY = {
  OFFLINE: 0,
  ONLINE: 1
} as const

// Busy status 
export const BUSY_STATUS = {
  NON_BUSY: 1,
  BUSY: 2
} as const
